var _style, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes check {\r\nto {\r\n        stroke-dashoffset: 0;\r\n      }\r\n}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8,
    stroke: "#0A0A30",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#23C45E",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M9.215 12.052l1.822 1.805 3.748-3.714",
    style: {
      animation: "check 2s infinite cubic-bezier(.99,-.1,.01,1.02)"
    },
    strokeDashoffset: 100,
    strokeDasharray: 100
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.9aac5bcb4a5dd9f1e491502fa95ded1d.svg";
export { ForwardRef as ReactComponent };